import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import { TrustpilotWidget } from '../../../..';

import { TEMPLATE_IDS } from '../TrustpilotWidget/TrustpilotWidget';

import Section from '../LandingSection/LandingSection';

import styles from './LandingTestimonialsSection.module.scss';

const LandingTestimonialsSection = ({
  renderTitle = null,
  backgroundColor = 'white'
}) => {
  return (
    <Section
      className={classNames(
        styles['landing-testimonials-section'],
        styles[`landing-testimonials-section--${backgroundColor}`]
      )}
    >
      {renderTitle ? (
        renderTitle()
      ) : (
        <h2 className={styles['landing-testimonials-section__title']}>
          {trans('how_it_works.testimonials.title')}
        </h2>
      )}
      <TrustpilotWidget
        className={styles['landing-testimonials-section__widget']}
        template={TEMPLATE_IDS.SLIDER}
        width="100%"
        height={160}
      />
    </Section>
  );
};

LandingTestimonialsSection.propTypes = {
  renderTitle: PropTypes.func,
  backgroundColor: PropTypes.oneOf(['secondary-blue-light', 'white'])
};

export default LandingTestimonialsSection;
